import React, { SyntheticEvent, useContext } from "react";
import { Dropdown } from "@cmsgov/ds-medicare-gov";
import { addNewRelicPageAction, useTranslate } from "../../../helpers";
import { CCXPDropdown } from "../../../components";
import { SearchFilterKeys } from "./constants";
import { searchResultsFilterAnalytics } from "./helpers";
import { AppStore } from "../../../app/store";
import { NewRelicPageActionNames } from "../../../@types";
import { AnalyticsActionType } from "../../../app/contexts/Analytics/types";

interface Props {
  value: string;
  options: { label: string; value: string }[];
  onFilterUpdate: (carrier: string) => void;
  basicMode?: boolean;
}

const CarrierFilter: React.FunctionComponent<Props> = ({
  options,
  value,
  onFilterUpdate,
  basicMode,
}) => {
  const t = useTranslate();
  const { dispatch } = useContext(AppStore.AppContext);

  const updateFilters = (newValue: string): void => {
    addNewRelicPageAction(NewRelicPageActionNames.SEARCH_RESULTS_FILTER, {
      filter: "Carrier Preference",
      value: newValue !== "" ? newValue : "Not Selected",
    });
    searchResultsFilterAnalytics({
      filterValue: newValue,
      filterType: SearchFilterKeys.insuranceCarrierFilter,
      dispatch,
    });
    dispatch({
      type: AnalyticsActionType.SEND_TEALIUM_EVENT,
      settings: {
        event_action: "Find Plans - Available Plans",
        event_label: "Insurance Carrier Pull down",
      },
    });
    onFilterUpdate(newValue);
  };

  const label = t("plan_terms.insurance_carrier");

  return basicMode ? (
    <Dropdown
      onChange={({
        currentTarget: { value },
      }: SyntheticEvent<HTMLSelectElement>): void => {
        updateFilters(value as string);
      }}
      name="preferred-insurance-carrier"
      value={value}
      label={label}
      id="preferred-insurance-carrier"
      options={[
        {
          label: t("app.terms.select_preferred_insurance_carrier"),
          value: "",
        },
        ...options,
      ]}
    />
  ) : (
    <div className="Filter">
      <CCXPDropdown
        label={label}
        size="widest"
        options={options}
        value={value}
        onUpdate={updateFilters}
        keepDefaultLabel
      />
    </div>
  );
};

export default CarrierFilter;
